export default __webpack_public_path__ + "static/media/Path 54352.7cb61f59.svg";